// Menu Header
export const LOAD_HEADER = 'header/LOAD_HEADER';
export const LOAD_HEADER_COMPLETE = 'header/LOAD_HEADER_COMPLETE';
export const LOAD_HEADER_ERROR = 'header/LOAD_HEADER_ERROR';
export const SET_QUERY_STRING = 'header/SET_QUERY_STRING';
export const LOGOUT = 'header/LOGOUT';
